export function matchesPattern(url: string, target: string): boolean {
  const regexPattern =
    '^' +
    target
      .replace(/\*/g, '[^/]+') // Match anything except '/'
      .replace(/\?/g, '\\?') // Escape '?'
      .replace(/=/g, '\\=') // Escape '='
      .replace(/([./])/g, '\\$1') +
    '$' // Escape special characters
  const pattern = new RegExp(regexPattern)
  return pattern.test(url)
}
